import { createSelector } from 'reselect';

import { getComponentProps } from '../form-designer/selectors/common.selectors';
import { isEmpty } from '../utils/ramdaUtils';

export const getProductHierarchy = (state) => state.productHierarchy;

export const getHierarchyLoading = createSelector(
  getProductHierarchy,
  (productHierarchy) => productHierarchy.loading
);

export const getIsParentLoading = createSelector(
  [getProductHierarchy, getComponentProps],
  (productHierarchy, { itemId }) => {
    const paginationList = productHierarchy.paginationList;

    if (isEmpty(paginationList)) {
      return false;
    }

    const currentItem = Object.keys(paginationList).filter((id) => id === itemId)[0];

    return paginationList[currentItem]?.isFetching;
  }
);

export const getIsChildrenPending = createSelector(getProductHierarchy, (productHierarchy) => {
  const paginationList = productHierarchy.paginationList;

  if (isEmpty(paginationList)) {
    return false;
  }

  return Object.values(paginationList).some((value) => value.isFetching === true);
});

export const getHierarchy = createSelector(
  getProductHierarchy,
  (productHierarchy) => productHierarchy.hierarchy
);

export const getIsNodeExpanded = createSelector(
  [getProductHierarchy, getComponentProps],
  (productHierarchy, { id }) => productHierarchy.expandedNodes.includes(id)
);
